import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

//

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

//

export function base64ToBlob(b64: string, mime = "application/pdf") {
  const clean = b64.replace(/^data:.*;base64,/, "");
  const bin = Uint8Array.from(atob(clean), (c) => c.charCodeAt(0));
  return new Blob([bin], { type: mime });
}

//

export function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
